/**
 * 查询保存服务接口
 * @description 用于保存用户自定义的查询语句
 */
export interface QuerySaveService {
    /**
     * 保存用户自定义查询语句
     * @param query - 用户输入的查询语句
     * @param searchIndex - 搜索索引
     * @returns 保存是否成功
     */
    saveQuery(query: string, searchIndex: number): Promise<boolean>;
}

export const QuerySaveService = Symbol('QuerySaveService');
